import axios from "@/config/axios.config";

import memberApi from "@/api/member";
// 订单确认
export function addressList(data) {
	return axios({
		url: memberApi.addressListUrl,
		method: "post",
		data,
	});
}

// 會員信息
export function memberData(data,noLoading) {
	return axios({
		method: "post",
		url: memberApi.getuserinfoUrl,
		data,
		noLoading
	});
}
// 充值
export function recharge(data) {
	return axios({
		method: "post",
		url: memberApi.rechargeUrl,
		data,
	});
}
// 充值次数限制
export function getCouponCountsByUCid(data) {
	return axios({
		method: "post",
		url: memberApi.getCouponCountsByUCidUrl,
		data,
	});
}
// 兑换码充值
export function rechargeCode(data) {
	return axios({
		method: "post",
		url: memberApi.rechargeCodeUrl,
		data,
	});
}
// 充值金额列表
export function rechargeList(data) {
	return axios({
		method: "post",
		url: memberApi.rechargeListUrl,
		data,
	});
}

// 地址列表
export function siteList(data, noToast = false) {
	return axios({
		method: "post",
		url: memberApi.addressListUrl,
		data,
		noToast,
	});
}

// 新增/編輯地址
export function addSite(data) {
	return axios({
		method: "post",
		url: memberApi.addAddressUrl,
		data,
	});
}

// 編輯地址詳情
export function addressDetail(data) {
	return axios({
		method: "post",
		url: memberApi.addressDetailUrl,
		data,
	});
}

// 账户/卡支出明细
export function accountOutput(data,noLoading = false) {
	return axios({
		method: "post",
		url: memberApi.accountOutputUrl,
        data,
        noLoading,
	});
}

// 账户/卡收入明细
export function accountInput(data,noLoading = false) {
	return axios({
		method: "post",
		url: memberApi.accountInputUrl,
        data,
        noLoading,
	});
}

// 绑定饭卡
export function bindCard(data) {
	return axios({
		method: "post",
		url: memberApi.bindCardUrl,
		data,
	});
}

// 解绑饭卡
export function unbindCard(data) {
	return axios({
		method: "post",
		url: memberApi.unbindCardUrl,
		data,
	});
}

// 饭卡流水
export function cardLog(data) {
	return axios({
		method: "post",
		url: memberApi.cardLogsUrl,
		data,
	});
}
// 账户列表
export function accountLog(data) {
	return axios({
		method: "post",
		url: memberApi.accountLogUrl,
		data,
	});
}

// 可用优惠券列表
export function coupon(data,noLoading = false) {
	return axios({
		method: "post",
		url: memberApi.couponUrl,
        data,
        noLoading
	});
}

// 历史优惠券列表
export function couponHistory(data,noLoading = false) {
	return axios({
		method: "post",
		url: memberApi.couponHistoryUrl,
        data,
        noLoading
	});
}

// 发票列表
export function invoiceList(data) {
	return axios({
		method: "post",
		url: memberApi.invoiceListUrl,
		data,
	});
}

// 发票详情
export function invoiceDetail(data) {
	return axios({
		method: "post",
		url: memberApi.invoiceDetailUrl,
		data,
	});
}

// 开票
export function addInvoice(data) {
	return axios({
		method: "post",
		url: memberApi.addInvoiceUrl,
		data,
	});
}

// 开票配置项
export function invoiceParam(data) {
	return axios({
		method: "post",
		url: memberApi.invoiceParamUrl,
		data,
	});
}

// 判断是否属于某个门店
export function addressType(data) {
	return axios({
		method: "post",
		url: memberApi.addressTypeUrl,
		data,
	});
}
